<template>
  <div class="triangle-bg">
    <page-sections :sections="page.fields.children" />
  </div>
</template>

<script>
import PageSections from '~/components/PageSections'

export default {
  components: {
    PageSections
  },
  asyncData: async function({ $api }) {
    return {
      page: await $api.getPage('menu/events')
    }
  },
  head: function() {
    return this.$metadata(this.page)
  },
  mounted() {
    if (document.querySelector('#food-packages') !== null) {
      document.querySelector('#food-packages').style.display = 'block' // Default section
    }
  }
}
</script>